/* jshint esversion: 6 */
import Demo from './demo'

const components = [
  Demo
]

const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default install



// WEBPACK FOOTER //
// ./src/components/index.js